import { OpenLRPointLocationReference } from './openlrpointlocationreference.model';

export class OpenLRExtendedPoint {
  openlrPointLocationReference: OpenLRPointLocationReference;
}



// WEBPACK FOOTER //
// ./src/app/models/openlr/openlrextendedpoint.model.ts